import { FC } from 'react';
import styled from 'styled-components';

import TopInfoMatchRendering from '../UtilitiesMatchMobile/GenericRenderingDefault/TopInfoMatchRendering';
import BottomInfoBeltAndNotesRendering from '../UtilitiesMatchMobile/GenericRenderingDefault/BottomInfoBeltAndNotesRendering';
import { Match } from '../../../../types';

const GenericContainerCard = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;


const CenterInfoMatch = styled.div`
    width: 100%;
    height: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;



const ThisWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
`;

const SpaceWrestler = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 25px;

    & img.space-wrestler-image {
        width: 20px;
        height: 100%;
        object-fit: cover;
        object-position: top;

    }

    & h2.name-wrestler {
        height: calc(100% - 20px);
        font-size: 5px;
        font-weight: 500;
        text-transform: uppercase;
        color: white;
        text-align: center;
        // Se troppo lungo o alto, metto ii puntini
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
}
`;

interface MobileDefaultMatchRenderProps {
    matchInfo: Match;
    withWinner?: boolean;
    isExpanded?: boolean;
}

const MobileDefaultMatchRender: FC<MobileDefaultMatchRenderProps> = ({ matchInfo, withWinner }) => {
    return (
        <GenericContainerCard className='mobile-default-match-render'>
            <TopInfoMatchRendering matchInfo={matchInfo} typeMatch="Default" />

            <CenterInfoMatch className='center-info-match'>
                <ThisWrapper className='this-wrapper'>
                    {matchInfo.wrestlers.map((wrestler, index) => (
                        <SpaceWrestler className='space-wrestler' key={index}>
                            <img
                             src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path}
                             alt={wrestler.name}
                             className='space-wrestler-image'
                            />
                            <h2 className='name-wrestler'>{wrestler.name}</h2>
                        </SpaceWrestler>
                    ))}
                </ThisWrapper>
            </CenterInfoMatch>

            <BottomInfoBeltAndNotesRendering matchInfo={matchInfo} />
        </GenericContainerCard>
    )
}

export default MobileDefaultMatchRender;
